// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"115":"b51890f3","369":"fd257d97","431":"9945a903","735":"505811be","867":"17ef1564"}[chunkId] + ".css";
};